/**
 * Do not edit directly, this file was auto-generated.
 */

export const ColorPrimary1 = '#027db6';
export const ColorPrimary2 = '#113988';
export const ColorPrimary3 = '#74d1f6';
export const ColorPrimary4 = '#52a53e';
export const ColorAccent1 = '#dc84b3';
export const ColorAccent2 = '#f7aa36';
export const ColorAccent3 = '#f5d816';
export const ColorAccent4 = '#d8273d';
export const ColorDark1 = '#12213f';
export const ColorDark2 = '#3d5870';
export const ColorDark3 = '#8292a5';
export const ColorBright1 = '#fffef9';
export const ColorBright2 = '#fffef9';
export const ColorBright3 = '#ccd5df';
export const ColorBright4 = '#e6f3f5';
export const ColorButtonSecondaryNormal = '#1198d6';
export const ColorButtonPrimaryNormal = '#113988';
export const ColorButtonSecondaryHover = '#1fb4f9';
export const ColorButtonPrimaryHover = '#1b51ba';
export const ColorPurchaseNormal = '#52a53e';
export const ColorPurchaseHover = '#67c550';
export const ColorLinkVisited = '#884488';
export const ColorLinkHover = '#bb1122';
export const ColorLinkNormal = '#3344dd';
export const GridBaseGrid4000 = {
  pattern: 'columns',
  gutterSize: 16,
  alignment: 'stretch',
  count: 12,
  offset: 16,
};
export const GridBaseGrid4001 = {
  pattern: 'rows',
  sectionSize: 8,
  gutterSize: 0,
  alignment: 'min',
  count: 1000,
  offset: 0,
};
export const GridBaseGrid4002 = {pattern: 'grid', sectionSize: 8};
export const GridBaseGrid608Span0 = {
  pattern: 'columns',
  gutterSize: 16,
  alignment: 'stretch',
  count: 12,
  offset: 24,
};
export const GridBaseGrid608Span1 = {
  pattern: 'rows',
  sectionSize: 8,
  gutterSize: 0,
  alignment: 'min',
  count: 1000,
  offset: 0,
};
export const GridBaseGrid608Span2 = {pattern: 'grid', sectionSize: 8};
export const GridBaseGrid816320 = {
  pattern: 'columns',
  gutterSize: 16,
  alignment: 'stretch',
  count: 12,
  offset: 32,
};
export const GridBaseGrid816321 = {
  pattern: 'rows',
  sectionSize: 8,
  gutterSize: 0,
  alignment: 'min',
  count: 1000,
  offset: 0,
};
export const GridBaseGrid816322 = {pattern: 'grid', sectionSize: 8};
export const GridBaseGrid1024400 = {
  pattern: 'columns',
  gutterSize: 16,
  alignment: 'stretch',
  count: 12,
  offset: 40,
};
export const GridBaseGrid1024401 = {
  pattern: 'rows',
  sectionSize: 8,
  gutterSize: 0,
  alignment: 'min',
  count: 1000,
  offset: 0,
};
export const GridBaseGrid1024402 = {pattern: 'grid', sectionSize: 8};
export const GridBaseGrid1200800 = {
  pattern: 'columns',
  gutterSize: 16,
  alignment: 'stretch',
  count: 12,
  offset: 80,
};
export const GridBaseGrid1200801 = {
  pattern: 'rows',
  sectionSize: 8,
  gutterSize: 0,
  alignment: 'min',
  count: 1000,
  offset: 0,
};
export const GridBaseGrid1200802 = {pattern: 'grid', sectionSize: 8};
export const GridBaseGrid1392800 = {
  pattern: 'columns',
  gutterSize: 16,
  alignment: 'stretch',
  count: 12,
  offset: 80,
};
export const GridBaseGrid1392801 = {
  pattern: 'rows',
  sectionSize: 8,
  gutterSize: 0,
  alignment: 'min',
  count: 1000,
  offset: 0,
};
export const GridBaseGrid1392802 = {pattern: 'grid', sectionSize: 8};
export const GridCard16pxMargin0 = {
  pattern: 'columns',
  gutterSize: 1,
  alignment: 'stretch',
  count: 1,
  offset: 16,
};
export const GridCard16pxMargin1 = {
  pattern: 'rows',
  gutterSize: 1,
  alignment: 'stretch',
  count: 1,
  offset: 16,
};
export const GridCard16pxMargin2 = {
  pattern: 'rows',
  sectionSize: 8,
  gutterSize: 0,
  alignment: 'min',
  count: 1000,
  offset: 0,
};
export const GridCard16pxMargin3 = {pattern: 'grid', sectionSize: 8};
export const GridCard40pxMargin0 = {
  pattern: 'columns',
  gutterSize: 1,
  alignment: 'stretch',
  count: 1,
  offset: 40,
};
export const GridCard40pxMargin1 = {
  pattern: 'rows',
  gutterSize: 1,
  alignment: 'stretch',
  count: 1,
  offset: 40,
};
export const GridCard40pxMargin2 = {
  pattern: 'rows',
  sectionSize: 8,
  gutterSize: 0,
  alignment: 'min',
  count: 1000,
  offset: 0,
};
export const GridCard40pxMargin3 = {pattern: 'grid', sectionSize: 8};
export const GridCard24pxMargin0 = {
  pattern: 'columns',
  gutterSize: 1,
  alignment: 'stretch',
  count: 1,
  offset: 24,
};
export const GridCard24pxMargin1 = {
  pattern: 'rows',
  gutterSize: 1,
  alignment: 'stretch',
  count: 1,
  offset: 24,
};
export const GridCard24pxMargin2 = {
  pattern: 'rows',
  sectionSize: 8,
  gutterSize: 0,
  alignment: 'min',
  count: 1000,
  offset: 0,
};
export const GridCard24pxMargin3 = {pattern: 'grid', sectionSize: 8};
export const GridUiInput16x10pt0 = {
  pattern: 'columns',
  gutterSize: 1,
  alignment: 'stretch',
  count: 1,
  offset: 16,
};
export const GridUiInput16x10pt1 = {
  pattern: 'rows',
  gutterSize: 1,
  alignment: 'stretch',
  count: 1,
  offset: 12,
};
export const GridSpacing8pxGrid = {pattern: 'grid', sectionSize: 8};
export const GridSpacingVert8px = {
  pattern: 'rows',
  sectionSize: 8,
  gutterSize: 0,
  alignment: 'min',
  count: 1000,
  offset: 0,
};
export const GridInput16px0 = {
  pattern: 'columns',
  gutterSize: 1,
  alignment: 'stretch',
  count: 1,
  offset: 16,
};
export const GridInput16px1 = {
  pattern: 'rows',
  gutterSize: 1,
  alignment: 'stretch',
  count: 1,
  offset: 12,
};
export const GridHeroStandard4000 = {
  pattern: 'columns',
  gutterSize: 16,
  alignment: 'stretch',
  count: 12,
  offset: 16,
};
export const GridHeroStandard4001 = {
  pattern: 'rows',
  sectionSize: 8,
  gutterSize: 0,
  alignment: 'min',
  count: 1000,
  offset: 0,
};
export const GridHeroStandard4002 = {
  pattern: 'rows',
  sectionSize: 1,
  gutterSize: 20,
  alignment: 'min',
  count: 0,
  offset: 0,
};
export const GridHeroStandard4003 = {
  pattern: 'rows',
  sectionSize: 1,
  gutterSize: 0,
  alignment: 'max',
  count: 0,
  offset: 24,
};
export const GridHeroStandard4004 = {
  pattern: 'columns',
  gutterSize: 1,
  alignment: 'stretch',
  count: 1,
  offset: 16,
};
export const GridHeroStandard6080 = {
  pattern: 'columns',
  gutterSize: 16,
  alignment: 'stretch',
  count: 12,
  offset: 24,
};
export const GridHeroStandard6081 = {
  pattern: 'rows',
  sectionSize: 8,
  gutterSize: 0,
  alignment: 'min',
  count: 1000,
  offset: 0,
};
export const GridHeroStandard6082 = {
  pattern: 'rows',
  sectionSize: 1,
  gutterSize: 0,
  alignment: 'min',
  count: 0,
  offset: 632,
};
export const GridHeroStandard6083 = {
  pattern: 'rows',
  sectionSize: 1,
  gutterSize: 0,
  alignment: 'max',
  count: 0,
  offset: 24,
};
export const GridHeroStandard6084 = {
  pattern: 'columns',
  gutterSize: 1,
  alignment: 'stretch',
  count: 1,
  offset: 24,
};
export const GridHeroStandard8160 = {
  pattern: 'columns',
  gutterSize: 16,
  alignment: 'stretch',
  count: 12,
  offset: 32,
};
export const GridHeroStandard8161 = {
  pattern: 'rows',
  sectionSize: 8,
  gutterSize: 0,
  alignment: 'min',
  count: 1000,
  offset: 0,
};
export const GridHeroStandard8162 = {
  pattern: 'rows',
  sectionSize: 24,
  gutterSize: 1,
  alignment: 'min',
  count: 1,
  offset: 0,
};
export const GridHeroStandard8163 = {
  pattern: 'rows',
  sectionSize: 24,
  gutterSize: 1,
  alignment: 'max',
  count: 1,
  offset: 0,
};
export const GridHeroStandard8164 = {
  pattern: 'columns',
  gutterSize: 20,
  alignment: 'stretch',
  count: 1,
  offset: 96,
};
export const GridHeroStandard10240 = {
  pattern: 'columns',
  gutterSize: 16,
  alignment: 'stretch',
  count: 12,
  offset: 40,
};
export const GridHeroStandard10241 = {
  pattern: 'rows',
  sectionSize: 8,
  gutterSize: 0,
  alignment: 'min',
  count: 1000,
  offset: 0,
};
export const GridHeroStandard10242 = {
  pattern: 'rows',
  sectionSize: 40,
  gutterSize: 1,
  alignment: 'min',
  count: 1,
  offset: 0,
};
export const GridHeroStandard10243 = {
  pattern: 'rows',
  sectionSize: 40,
  gutterSize: 1,
  alignment: 'max',
  count: 1,
  offset: 0,
};
export const GridHeroStandard12000 = {
  pattern: 'columns',
  gutterSize: 16,
  alignment: 'stretch',
  count: 12,
  offset: 80,
};
export const GridHeroStandard12001 = {
  pattern: 'rows',
  sectionSize: 8,
  gutterSize: 0,
  alignment: 'min',
  count: 1000,
  offset: 0,
};
export const GridHeroStandard12002 = {
  pattern: 'rows',
  sectionSize: 40,
  gutterSize: 1,
  alignment: 'min',
  count: 1,
  offset: 0,
};
export const GridHeroStandard12003 = {
  pattern: 'rows',
  sectionSize: 40,
  gutterSize: 1,
  alignment: 'max',
  count: 1,
  offset: 0,
};
export const GridHeroStandard13920 = {
  pattern: 'columns',
  gutterSize: 16,
  alignment: 'stretch',
  count: 12,
  offset: 80,
};
export const GridHeroStandard13921 = {
  pattern: 'rows',
  sectionSize: 8,
  gutterSize: 0,
  alignment: 'min',
  count: 1000,
  offset: 0,
};
export const GridHeroStandard13922 = {
  pattern: 'rows',
  sectionSize: 40,
  gutterSize: 1,
  alignment: 'min',
  count: 1,
  offset: 0,
};
export const GridHeroStandard13923 = {
  pattern: 'rows',
  sectionSize: 40,
  gutterSize: 1,
  alignment: 'max',
  count: 1,
  offset: 0,
};
export const GridHeroStandard15360 = {
  pattern: 'columns',
  gutterSize: 16,
  alignment: 'stretch',
  count: 12,
  offset: 152,
};
export const GridHeroStandard15361 = {
  pattern: 'rows',
  sectionSize: 8,
  gutterSize: 0,
  alignment: 'min',
  count: 1000,
  offset: 0,
};
export const GridHeroStandard15362 = {
  pattern: 'rows',
  sectionSize: 40,
  gutterSize: 1,
  alignment: 'min',
  count: 1,
  offset: 0,
};
export const GridHeroStandard15363 = {
  pattern: 'rows',
  sectionSize: 40,
  gutterSize: 1,
  alignment: 'max',
  count: 1,
  offset: 0,
};
export const GridHeroStandard18400 = {
  pattern: 'columns',
  gutterSize: 16,
  alignment: 'stretch',
  count: 12,
  offset: 304,
};
export const GridHeroStandard18401 = {
  pattern: 'rows',
  sectionSize: 8,
  gutterSize: 0,
  alignment: 'min',
  count: 1000,
  offset: 0,
};
export const GridHeroStandard18402 = {
  pattern: 'rows',
  sectionSize: 40,
  gutterSize: 1,
  alignment: 'min',
  count: 1,
  offset: 0,
};
export const GridHeroStandard18403 = {
  pattern: 'rows',
  sectionSize: 40,
  gutterSize: 1,
  alignment: 'max',
  count: 1,
  offset: 0,
};
export const FontHeader164112Left21 = {
  fontSize: 64,
  textDecoration: 'none',
  fontFamily: 'Left 2.1',
  fontWeight: 700,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 1.5,
  lineHeight: 71.68,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontHeader248116Left21 = {
  fontSize: 48,
  textDecoration: 'none',
  fontFamily: 'Left 2.1',
  fontWeight: 700,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 1.5,
  lineHeight: 55.68,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontHeader340120Left21 = {
  fontSize: 40,
  textDecoration: 'none',
  fontFamily: 'Left 2.1',
  fontWeight: 700,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 1.5,
  lineHeight: 48,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontHeader432124Left21 = {
  fontSize: 32,
  textDecoration: 'none',
  fontFamily: 'Left 2.1',
  fontWeight: 700,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 1,
  lineHeight: 39.68,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontHeader524135Left21 = {
  fontSize: 24,
  textDecoration: 'none',
  fontFamily: 'Left 2.1',
  fontWeight: 700,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0.9,
  lineHeight: 32.4,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontHeader620160Left21 = {
  fontSize: 20,
  textDecoration: 'none',
  fontFamily: 'Left 2.1',
  fontWeight: 700,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0.5,
  lineHeight: 32,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontMHeader148124Left21 = {
  fontSize: 48,
  textDecoration: 'none',
  fontFamily: 'Left 2.1',
  fontWeight: 700,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0,
  lineHeight: 59.52,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontMHeader240120Left21 = {
  fontSize: 40,
  textDecoration: 'none',
  fontFamily: 'Left 2.1',
  fontWeight: 700,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0,
  lineHeight: 48,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontMHeader332124Left21 = {
  fontSize: 32,
  textDecoration: 'none',
  fontFamily: 'Left 2.1',
  fontWeight: 700,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0,
  lineHeight: 39.68,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontMHeader428142Left21 = {
  fontSize: 28,
  textDecoration: 'none',
  fontFamily: 'Left 2.1',
  fontWeight: 700,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0,
  lineHeight: 39.76,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontMHeader524135Left21 = {
  fontSize: 24,
  textDecoration: 'none',
  fontFamily: 'Left 2.1',
  fontWeight: 700,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0,
  lineHeight: 32.4,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontMHeader620160Left21 = {
  fontSize: 20,
  textDecoration: 'none',
  fontFamily: 'Left 2.1',
  fontWeight: 700,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0,
  lineHeight: 32,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontBody124165BrSojnoma = {
  fontSize: 24,
  textDecoration: 'none',
  fontFamily: 'BR Sonoma',
  fontWeight: 400,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0,
  lineHeight: 39.6,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontBody220160BrSojnoma = {
  fontSize: 20,
  textDecoration: 'none',
  fontFamily: 'BR Sonoma',
  fontWeight: 500,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0,
  lineHeight: 32,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontBody318135BrSonoma = {
  fontSize: 18,
  textDecoration: 'none',
  fontFamily: 'BR Sonoma',
  fontWeight: 500,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0.5,
  lineHeight: 24.3,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontBody416147BrSonoma = {
  fontSize: 16,
  textDecoration: 'none',
  fontFamily: 'BR Sonoma',
  fontWeight: 500,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0.5,
  lineHeight: 23.52,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontBody514170BrSonoma = {
  fontSize: 14,
  textDecoration: 'none',
  fontFamily: 'BR Sonoma',
  fontWeight: 500,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0.5,
  lineHeight: 23.8,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontBody612130BrSonoma = {
  fontSize: 12,
  textDecoration: 'none',
  fontFamily: 'BR Sonoma',
  fontWeight: 500,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0.5,
  lineHeight: 15.6,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontBody1m20160BrSonoma = {
  fontSize: 24,
  textDecoration: 'none',
  fontFamily: 'BR Sonoma',
  fontWeight: 700,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0.5,
  lineHeight: 39.6,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontBody2m20160BrSonoma = {
  fontSize: 20,
  textDecoration: 'none',
  fontFamily: 'BR Sonoma',
  fontWeight: 700,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0.5,
  lineHeight: 32,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontBody3m18135BrSonoma = {
  fontSize: 18,
  textDecoration: 'none',
  fontFamily: 'BR Sonoma',
  fontWeight: 700,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0.5,
  lineHeight: 24.3,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontBody4m16147BrSonoma = {
  fontSize: 16,
  textDecoration: 'none',
  fontFamily: 'BR Sonoma',
  fontWeight: 700,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0.5,
  lineHeight: 23.52,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontBody5m14170BrSonoma = {
  fontSize: 14,
  textDecoration: 'none',
  fontFamily: 'BR Sonoma',
  fontWeight: 700,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0.5,
  lineHeight: 23.8,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontBody6m12130BrSonoma = {
  fontSize: 12,
  textDecoration: 'none',
  fontFamily: 'BR Sonoma',
  fontWeight: 700,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0.5,
  lineHeight: 15.6,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontLink120160BrSonoma = {
  fontSize: 24,
  textDecoration: 'underline',
  fontFamily: 'BR Sonoma',
  fontWeight: 400,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 2.5,
  lineHeight: 39.6,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontLink220160BrSonoma = {
  fontSize: 20,
  textDecoration: 'underline',
  fontFamily: 'BR Sonoma',
  fontWeight: 400,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 2.5,
  lineHeight: 32,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontLink318135BrSonoma = {
  fontSize: 18,
  textDecoration: 'underline',
  fontFamily: 'BR Sonoma',
  fontWeight: 400,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 2.5,
  lineHeight: 24.3,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontLink416150BrSonoma = {
  fontSize: 16,
  textDecoration: 'underline',
  fontFamily: 'BR Sonoma',
  fontWeight: 400,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 2.5,
  lineHeight: 24,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontLink514170BrSonoma = {
  fontSize: 14,
  textDecoration: 'underline',
  fontFamily: 'BR Sonoma',
  fontWeight: 400,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 2.5,
  lineHeight: 23.8,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontLink612160BrSonoma = {
  fontSize: 12,
  textDecoration: 'underline',
  fontFamily: 'BR Sonoma',
  fontWeight: 500,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 2.5,
  lineHeight: 24,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontButtonSmall16150BrSonoma = {
  fontSize: 16,
  textDecoration: 'none',
  fontFamily: 'BR Sonoma',
  fontWeight: 700,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 2,
  lineHeight: 24,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontButtonBig28132BrSonoma = {
  fontSize: 28,
  textDecoration: 'none',
  fontFamily: 'BR Sonoma',
  fontWeight: 400,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 2,
  lineHeight: 39.76,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontSpecialTerms10145BrSonoma = {
  fontSize: 11,
  textDecoration: 'none',
  fontFamily: 'BR Sonoma',
  fontWeight: 500,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0,
  lineHeight: 15.95,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontSpecialTermsLink10145BrSonoma = {
  fontSize: 10,
  textDecoration: 'underline',
  fontFamily: 'BR Sonoma',
  fontWeight: 400,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0,
  lineHeight: 16,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontSpecialNav16150BrSonoma = {
  fontSize: 16,
  textDecoration: 'none',
  fontFamily: 'BR Sonoma',
  fontWeight: 500,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0.4,
  lineHeight: 24,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'uppercase',
};
export const FontSpecialInputError12130BrSonoma = {
  fontSize: 12,
  textDecoration: 'none',
  fontFamily: 'BR Sonoma',
  fontWeight: 700,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0,
  lineHeight: 15.6,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontSpecialCaption14170BrSonoma = {
  fontSize: 14,
  textDecoration: 'none',
  fontFamily: 'BR Sonoma',
  fontWeight: 500,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0.5,
  lineHeight: 23.8,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontSpecialCaptionItalic14170BrSonoma = {
  fontSize: 14,
  textDecoration: 'none',
  fontFamily: 'BR Sonoma',
  fontWeight: 500,
  fontStyle: 'italic',
  fontStretch: 'normal',
  letterSpacing: 0.5,
  lineHeight: 23.8,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontSpecialTmHighlight10145BrSonoma = {
  fontSize: 10,
  textDecoration: 'none',
  fontFamily: 'Left 2.1',
  fontWeight: 500,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0,
  lineHeight: 16,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontSubtitle114168BrSonoma = {
  fontSize: 14,
  textDecoration: 'none',
  fontFamily: 'BR Sonoma',
  fontWeight: 500,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0.5,
  lineHeight: 23.52,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontSubtitle212135BrSonoma = {
  fontSize: 12,
  textDecoration: 'none',
  fontFamily: 'BR Sonoma',
  fontWeight: 500,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: 0.5,
  lineHeight: 16.2,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontOversize1192121Left21 = {
  fontSize: 192,
  textDecoration: 'none',
  fontFamily: 'Left 2.1',
  fontWeight: 500,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: -3.84,
  lineHeight: 232.32,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontOversize2128128Left21 = {
  fontSize: 128,
  textDecoration: 'none',
  fontFamily: 'Left 2.1',
  fontWeight: 500,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: -2.56,
  lineHeight: 144,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const FontOversize36464Left21 = {
  fontSize: 64,
  textDecoration: 'none',
  fontFamily: 'Left 2.1',
  fontWeight: 500,
  fontStyle: 'normal',
  fontStretch: 'normal',
  letterSpacing: -1.28,
  lineHeight: 64,
  paragraphIndent: 0,
  paragraphSpacing: 0,
  textCase: 'none',
};
export const EffectToggle = {
  shadowType: 'innerShadow',
  radius: 3,
  color: '#00000040',
  offsetX: 1,
  offsetY: 2,
  spread: 0,
};
export const EffectCart = {
  shadowType: 'dropShadow',
  radius: 3,
  color: '#00000026',
  offsetX: 0,
  offsetY: -3,
  spread: 0,
};
export const EffectDepthLow = {
  shadowType: 'dropShadow',
  radius: 3,
  color: '#00000033',
  offsetX: 0,
  offsetY: 2,
  spread: 0,
};
export const EffectDepthHigh = {
  shadowType: 'dropShadow',
  radius: 16,
  color: '#00000033',
  offsetX: 0,
  offsetY: 4,
  spread: 0,
};
export const EffectCardHover = {
  shadowType: 'dropShadow',
  radius: 2,
  color: '#00000026',
  offsetX: 0,
  offsetY: 2,
  spread: 0,
};
export const EffectCardTrial = {
  shadowType: 'dropShadow',
  radius: 4,
  color: '#0000001a',
  offsetX: 0,
  offsetY: 4,
  spread: 0,
};
export const TypographyHeader164112Left21FontSize = '64rem';
export const TypographyHeader164112Left21TextDecoration = 'none';
export const TypographyHeader164112Left21FontFamily = 'Left 2.1';
export const TypographyHeader164112Left21FontWeight = 700;
export const TypographyHeader164112Left21FontStyle = 'normal';
export const TypographyHeader164112Left21FontStretch = 'normal';
export const TypographyHeader164112Left21LetterSpacing = '1.5rem';
export const TypographyHeader164112Left21LineHeight = '71.68rem';
export const TypographyHeader164112Left21ParagraphIndent = '0rem';
export const TypographyHeader164112Left21ParagraphSpacing = '0rem';
export const TypographyHeader164112Left21TextCase = 'none';
export const TypographyHeader248116Left21FontSize = '48rem';
export const TypographyHeader248116Left21TextDecoration = 'none';
export const TypographyHeader248116Left21FontFamily = 'Left 2.1';
export const TypographyHeader248116Left21FontWeight = 700;
export const TypographyHeader248116Left21FontStyle = 'normal';
export const TypographyHeader248116Left21FontStretch = 'normal';
export const TypographyHeader248116Left21LetterSpacing = '1.5rem';
export const TypographyHeader248116Left21LineHeight = '55.68rem';
export const TypographyHeader248116Left21ParagraphIndent = '0rem';
export const TypographyHeader248116Left21ParagraphSpacing = '0rem';
export const TypographyHeader248116Left21TextCase = 'none';
export const TypographyHeader340120Left21FontSize = '40rem';
export const TypographyHeader340120Left21TextDecoration = 'none';
export const TypographyHeader340120Left21FontFamily = 'Left 2.1';
export const TypographyHeader340120Left21FontWeight = 700;
export const TypographyHeader340120Left21FontStyle = 'normal';
export const TypographyHeader340120Left21FontStretch = 'normal';
export const TypographyHeader340120Left21LetterSpacing = '1.5rem';
export const TypographyHeader340120Left21LineHeight = '48rem';
export const TypographyHeader340120Left21ParagraphIndent = '0rem';
export const TypographyHeader340120Left21ParagraphSpacing = '0rem';
export const TypographyHeader340120Left21TextCase = 'none';
export const TypographyHeader432124Left21FontSize = '32rem';
export const TypographyHeader432124Left21TextDecoration = 'none';
export const TypographyHeader432124Left21FontFamily = 'Left 2.1';
export const TypographyHeader432124Left21FontWeight = 700;
export const TypographyHeader432124Left21FontStyle = 'normal';
export const TypographyHeader432124Left21FontStretch = 'normal';
export const TypographyHeader432124Left21LetterSpacing = '1rem';
export const TypographyHeader432124Left21LineHeight = '39.68rem';
export const TypographyHeader432124Left21ParagraphIndent = '0rem';
export const TypographyHeader432124Left21ParagraphSpacing = '0rem';
export const TypographyHeader432124Left21TextCase = 'none';
export const TypographyHeader524135Left21FontSize = '24rem';
export const TypographyHeader524135Left21TextDecoration = 'none';
export const TypographyHeader524135Left21FontFamily = 'Left 2.1';
export const TypographyHeader524135Left21FontWeight = 700;
export const TypographyHeader524135Left21FontStyle = 'normal';
export const TypographyHeader524135Left21FontStretch = 'normal';
export const TypographyHeader524135Left21LetterSpacing = '0.9rem';
export const TypographyHeader524135Left21LineHeight = '32.4rem';
export const TypographyHeader524135Left21ParagraphIndent = '0rem';
export const TypographyHeader524135Left21ParagraphSpacing = '0rem';
export const TypographyHeader524135Left21TextCase = 'none';
export const TypographyHeader620160Left21FontSize = '20rem';
export const TypographyHeader620160Left21TextDecoration = 'none';
export const TypographyHeader620160Left21FontFamily = 'Left 2.1';
export const TypographyHeader620160Left21FontWeight = 700;
export const TypographyHeader620160Left21FontStyle = 'normal';
export const TypographyHeader620160Left21FontStretch = 'normal';
export const TypographyHeader620160Left21LetterSpacing = '0.5rem';
export const TypographyHeader620160Left21LineHeight = '32rem';
export const TypographyHeader620160Left21ParagraphIndent = '0rem';
export const TypographyHeader620160Left21ParagraphSpacing = '0rem';
export const TypographyHeader620160Left21TextCase = 'none';
export const TypographyMHeader148124Left21FontSize = '48rem';
export const TypographyMHeader148124Left21TextDecoration = 'none';
export const TypographyMHeader148124Left21FontFamily = 'Left 2.1';
export const TypographyMHeader148124Left21FontWeight = 700;
export const TypographyMHeader148124Left21FontStyle = 'normal';
export const TypographyMHeader148124Left21FontStretch = 'normal';
export const TypographyMHeader148124Left21LetterSpacing = '0rem';
export const TypographyMHeader148124Left21LineHeight = '59.52rem';
export const TypographyMHeader148124Left21ParagraphIndent = '0rem';
export const TypographyMHeader148124Left21ParagraphSpacing = '0rem';
export const TypographyMHeader148124Left21TextCase = 'none';
export const TypographyMHeader240120Left21FontSize = '40rem';
export const TypographyMHeader240120Left21TextDecoration = 'none';
export const TypographyMHeader240120Left21FontFamily = 'Left 2.1';
export const TypographyMHeader240120Left21FontWeight = 700;
export const TypographyMHeader240120Left21FontStyle = 'normal';
export const TypographyMHeader240120Left21FontStretch = 'normal';
export const TypographyMHeader240120Left21LetterSpacing = '0rem';
export const TypographyMHeader240120Left21LineHeight = '48rem';
export const TypographyMHeader240120Left21ParagraphIndent = '0rem';
export const TypographyMHeader240120Left21ParagraphSpacing = '0rem';
export const TypographyMHeader240120Left21TextCase = 'none';
export const TypographyMHeader332124Left21FontSize = '32rem';
export const TypographyMHeader332124Left21TextDecoration = 'none';
export const TypographyMHeader332124Left21FontFamily = 'Left 2.1';
export const TypographyMHeader332124Left21FontWeight = 700;
export const TypographyMHeader332124Left21FontStyle = 'normal';
export const TypographyMHeader332124Left21FontStretch = 'normal';
export const TypographyMHeader332124Left21LetterSpacing = '0rem';
export const TypographyMHeader332124Left21LineHeight = '39.68rem';
export const TypographyMHeader332124Left21ParagraphIndent = '0rem';
export const TypographyMHeader332124Left21ParagraphSpacing = '0rem';
export const TypographyMHeader332124Left21TextCase = 'none';
export const TypographyMHeader428142Left21FontSize = '28rem';
export const TypographyMHeader428142Left21TextDecoration = 'none';
export const TypographyMHeader428142Left21FontFamily = 'Left 2.1';
export const TypographyMHeader428142Left21FontWeight = 700;
export const TypographyMHeader428142Left21FontStyle = 'normal';
export const TypographyMHeader428142Left21FontStretch = 'normal';
export const TypographyMHeader428142Left21LetterSpacing = '0rem';
export const TypographyMHeader428142Left21LineHeight = '39.76rem';
export const TypographyMHeader428142Left21ParagraphIndent = '0rem';
export const TypographyMHeader428142Left21ParagraphSpacing = '0rem';
export const TypographyMHeader428142Left21TextCase = 'none';
export const TypographyMHeader524135Left21FontSize = '24rem';
export const TypographyMHeader524135Left21TextDecoration = 'none';
export const TypographyMHeader524135Left21FontFamily = 'Left 2.1';
export const TypographyMHeader524135Left21FontWeight = 700;
export const TypographyMHeader524135Left21FontStyle = 'normal';
export const TypographyMHeader524135Left21FontStretch = 'normal';
export const TypographyMHeader524135Left21LetterSpacing = '0rem';
export const TypographyMHeader524135Left21LineHeight = '32.4rem';
export const TypographyMHeader524135Left21ParagraphIndent = '0rem';
export const TypographyMHeader524135Left21ParagraphSpacing = '0rem';
export const TypographyMHeader524135Left21TextCase = 'none';
export const TypographyMHeader620160Left21FontSize = '20rem';
export const TypographyMHeader620160Left21TextDecoration = 'none';
export const TypographyMHeader620160Left21FontFamily = 'Left 2.1';
export const TypographyMHeader620160Left21FontWeight = 700;
export const TypographyMHeader620160Left21FontStyle = 'normal';
export const TypographyMHeader620160Left21FontStretch = 'normal';
export const TypographyMHeader620160Left21LetterSpacing = '0rem';
export const TypographyMHeader620160Left21LineHeight = '32rem';
export const TypographyMHeader620160Left21ParagraphIndent = '0rem';
export const TypographyMHeader620160Left21ParagraphSpacing = '0rem';
export const TypographyMHeader620160Left21TextCase = 'none';
export const TypographyBody124165BrSojnomaFontSize = '24rem';
export const TypographyBody124165BrSojnomaTextDecoration = 'none';
export const TypographyBody124165BrSojnomaFontFamily = 'BR Sonoma';
export const TypographyBody124165BrSojnomaFontWeight = 400;
export const TypographyBody124165BrSojnomaFontStyle = 'normal';
export const TypographyBody124165BrSojnomaFontStretch = 'normal';
export const TypographyBody124165BrSojnomaLetterSpacing = '0rem';
export const TypographyBody124165BrSojnomaLineHeight = '39.6rem';
export const TypographyBody124165BrSojnomaParagraphIndent = '0rem';
export const TypographyBody124165BrSojnomaParagraphSpacing = '0rem';
export const TypographyBody124165BrSojnomaTextCase = 'none';
export const TypographyBody220160BrSojnomaFontSize = '20rem';
export const TypographyBody220160BrSojnomaTextDecoration = 'none';
export const TypographyBody220160BrSojnomaFontFamily = 'BR Sonoma';
export const TypographyBody220160BrSojnomaFontWeight = 500;
export const TypographyBody220160BrSojnomaFontStyle = 'normal';
export const TypographyBody220160BrSojnomaFontStretch = 'normal';
export const TypographyBody220160BrSojnomaLetterSpacing = '0rem';
export const TypographyBody220160BrSojnomaLineHeight = '32rem';
export const TypographyBody220160BrSojnomaParagraphIndent = '0rem';
export const TypographyBody220160BrSojnomaParagraphSpacing = '0rem';
export const TypographyBody220160BrSojnomaTextCase = 'none';
export const TypographyBody318135BrSonomaFontSize = '18rem';
export const TypographyBody318135BrSonomaTextDecoration = 'none';
export const TypographyBody318135BrSonomaFontFamily = 'BR Sonoma';
export const TypographyBody318135BrSonomaFontWeight = 500;
export const TypographyBody318135BrSonomaFontStyle = 'normal';
export const TypographyBody318135BrSonomaFontStretch = 'normal';
export const TypographyBody318135BrSonomaLetterSpacing = '0.5rem';
export const TypographyBody318135BrSonomaLineHeight = '24.3rem';
export const TypographyBody318135BrSonomaParagraphIndent = '0rem';
export const TypographyBody318135BrSonomaParagraphSpacing = '0rem';
export const TypographyBody318135BrSonomaTextCase = 'none';
export const TypographyBody416147BrSonomaFontSize = '16rem';
export const TypographyBody416147BrSonomaTextDecoration = 'none';
export const TypographyBody416147BrSonomaFontFamily = 'BR Sonoma';
export const TypographyBody416147BrSonomaFontWeight = 500;
export const TypographyBody416147BrSonomaFontStyle = 'normal';
export const TypographyBody416147BrSonomaFontStretch = 'normal';
export const TypographyBody416147BrSonomaLetterSpacing = '0.5rem';
export const TypographyBody416147BrSonomaLineHeight = '23.52rem';
export const TypographyBody416147BrSonomaParagraphIndent = '0rem';
export const TypographyBody416147BrSonomaParagraphSpacing = '0rem';
export const TypographyBody416147BrSonomaTextCase = 'none';
export const TypographyBody514170BrSonomaFontSize = '14rem';
export const TypographyBody514170BrSonomaTextDecoration = 'none';
export const TypographyBody514170BrSonomaFontFamily = 'BR Sonoma';
export const TypographyBody514170BrSonomaFontWeight = 500;
export const TypographyBody514170BrSonomaFontStyle = 'normal';
export const TypographyBody514170BrSonomaFontStretch = 'normal';
export const TypographyBody514170BrSonomaLetterSpacing = '0.5rem';
export const TypographyBody514170BrSonomaLineHeight = '23.8rem';
export const TypographyBody514170BrSonomaParagraphIndent = '0rem';
export const TypographyBody514170BrSonomaParagraphSpacing = '0rem';
export const TypographyBody514170BrSonomaTextCase = 'none';
export const TypographyBody612130BrSonomaFontSize = '12rem';
export const TypographyBody612130BrSonomaTextDecoration = 'none';
export const TypographyBody612130BrSonomaFontFamily = 'BR Sonoma';
export const TypographyBody612130BrSonomaFontWeight = 500;
export const TypographyBody612130BrSonomaFontStyle = 'normal';
export const TypographyBody612130BrSonomaFontStretch = 'normal';
export const TypographyBody612130BrSonomaLetterSpacing = '0.5rem';
export const TypographyBody612130BrSonomaLineHeight = '15.6rem';
export const TypographyBody612130BrSonomaParagraphIndent = '0rem';
export const TypographyBody612130BrSonomaParagraphSpacing = '0rem';
export const TypographyBody612130BrSonomaTextCase = 'none';
export const TypographyBody1m20160BrSonomaFontSize = '24rem';
export const TypographyBody1m20160BrSonomaTextDecoration = 'none';
export const TypographyBody1m20160BrSonomaFontFamily = 'BR Sonoma';
export const TypographyBody1m20160BrSonomaFontWeight = 700;
export const TypographyBody1m20160BrSonomaFontStyle = 'normal';
export const TypographyBody1m20160BrSonomaFontStretch = 'normal';
export const TypographyBody1m20160BrSonomaLetterSpacing = '0.5rem';
export const TypographyBody1m20160BrSonomaLineHeight = '39.6rem';
export const TypographyBody1m20160BrSonomaParagraphIndent = '0rem';
export const TypographyBody1m20160BrSonomaParagraphSpacing = '0rem';
export const TypographyBody1m20160BrSonomaTextCase = 'none';
export const TypographyBody2m20160BrSonomaFontSize = '20rem';
export const TypographyBody2m20160BrSonomaTextDecoration = 'none';
export const TypographyBody2m20160BrSonomaFontFamily = 'BR Sonoma';
export const TypographyBody2m20160BrSonomaFontWeight = 700;
export const TypographyBody2m20160BrSonomaFontStyle = 'normal';
export const TypographyBody2m20160BrSonomaFontStretch = 'normal';
export const TypographyBody2m20160BrSonomaLetterSpacing = '0.5rem';
export const TypographyBody2m20160BrSonomaLineHeight = '32rem';
export const TypographyBody2m20160BrSonomaParagraphIndent = '0rem';
export const TypographyBody2m20160BrSonomaParagraphSpacing = '0rem';
export const TypographyBody2m20160BrSonomaTextCase = 'none';
export const TypographyBody3m18135BrSonomaFontSize = '18rem';
export const TypographyBody3m18135BrSonomaTextDecoration = 'none';
export const TypographyBody3m18135BrSonomaFontFamily = 'BR Sonoma';
export const TypographyBody3m18135BrSonomaFontWeight = 700;
export const TypographyBody3m18135BrSonomaFontStyle = 'normal';
export const TypographyBody3m18135BrSonomaFontStretch = 'normal';
export const TypographyBody3m18135BrSonomaLetterSpacing = '0.5rem';
export const TypographyBody3m18135BrSonomaLineHeight = '24.3rem';
export const TypographyBody3m18135BrSonomaParagraphIndent = '0rem';
export const TypographyBody3m18135BrSonomaParagraphSpacing = '0rem';
export const TypographyBody3m18135BrSonomaTextCase = 'none';
export const TypographyBody4m16147BrSonomaFontSize = '16rem';
export const TypographyBody4m16147BrSonomaTextDecoration = 'none';
export const TypographyBody4m16147BrSonomaFontFamily = 'BR Sonoma';
export const TypographyBody4m16147BrSonomaFontWeight = 700;
export const TypographyBody4m16147BrSonomaFontStyle = 'normal';
export const TypographyBody4m16147BrSonomaFontStretch = 'normal';
export const TypographyBody4m16147BrSonomaLetterSpacing = '0.5rem';
export const TypographyBody4m16147BrSonomaLineHeight = '23.52rem';
export const TypographyBody4m16147BrSonomaParagraphIndent = '0rem';
export const TypographyBody4m16147BrSonomaParagraphSpacing = '0rem';
export const TypographyBody4m16147BrSonomaTextCase = 'none';
export const TypographyBody5m14170BrSonomaFontSize = '14rem';
export const TypographyBody5m14170BrSonomaTextDecoration = 'none';
export const TypographyBody5m14170BrSonomaFontFamily = 'BR Sonoma';
export const TypographyBody5m14170BrSonomaFontWeight = 700;
export const TypographyBody5m14170BrSonomaFontStyle = 'normal';
export const TypographyBody5m14170BrSonomaFontStretch = 'normal';
export const TypographyBody5m14170BrSonomaLetterSpacing = '0.5rem';
export const TypographyBody5m14170BrSonomaLineHeight = '23.8rem';
export const TypographyBody5m14170BrSonomaParagraphIndent = '0rem';
export const TypographyBody5m14170BrSonomaParagraphSpacing = '0rem';
export const TypographyBody5m14170BrSonomaTextCase = 'none';
export const TypographyBody6m12130BrSonomaFontSize = '12rem';
export const TypographyBody6m12130BrSonomaTextDecoration = 'none';
export const TypographyBody6m12130BrSonomaFontFamily = 'BR Sonoma';
export const TypographyBody6m12130BrSonomaFontWeight = 700;
export const TypographyBody6m12130BrSonomaFontStyle = 'normal';
export const TypographyBody6m12130BrSonomaFontStretch = 'normal';
export const TypographyBody6m12130BrSonomaLetterSpacing = '0.5rem';
export const TypographyBody6m12130BrSonomaLineHeight = '15.6rem';
export const TypographyBody6m12130BrSonomaParagraphIndent = '0rem';
export const TypographyBody6m12130BrSonomaParagraphSpacing = '0rem';
export const TypographyBody6m12130BrSonomaTextCase = 'none';
export const TypographyLink120160BrSonomaFontSize = '24rem';
export const TypographyLink120160BrSonomaTextDecoration = 'underline';
export const TypographyLink120160BrSonomaFontFamily = 'BR Sonoma';
export const TypographyLink120160BrSonomaFontWeight = 400;
export const TypographyLink120160BrSonomaFontStyle = 'normal';
export const TypographyLink120160BrSonomaFontStretch = 'normal';
export const TypographyLink120160BrSonomaLetterSpacing = '2.5rem';
export const TypographyLink120160BrSonomaLineHeight = '39.6rem';
export const TypographyLink120160BrSonomaParagraphIndent = '0rem';
export const TypographyLink120160BrSonomaParagraphSpacing = '0rem';
export const TypographyLink120160BrSonomaTextCase = 'none';
export const TypographyLink220160BrSonomaFontSize = '20rem';
export const TypographyLink220160BrSonomaTextDecoration = 'underline';
export const TypographyLink220160BrSonomaFontFamily = 'BR Sonoma';
export const TypographyLink220160BrSonomaFontWeight = 400;
export const TypographyLink220160BrSonomaFontStyle = 'normal';
export const TypographyLink220160BrSonomaFontStretch = 'normal';
export const TypographyLink220160BrSonomaLetterSpacing = '2.5rem';
export const TypographyLink220160BrSonomaLineHeight = '32rem';
export const TypographyLink220160BrSonomaParagraphIndent = '0rem';
export const TypographyLink220160BrSonomaParagraphSpacing = '0rem';
export const TypographyLink220160BrSonomaTextCase = 'none';
export const TypographyLink318135BrSonomaFontSize = '18rem';
export const TypographyLink318135BrSonomaTextDecoration = 'underline';
export const TypographyLink318135BrSonomaFontFamily = 'BR Sonoma';
export const TypographyLink318135BrSonomaFontWeight = 400;
export const TypographyLink318135BrSonomaFontStyle = 'normal';
export const TypographyLink318135BrSonomaFontStretch = 'normal';
export const TypographyLink318135BrSonomaLetterSpacing = '2.5rem';
export const TypographyLink318135BrSonomaLineHeight = '24.3rem';
export const TypographyLink318135BrSonomaParagraphIndent = '0rem';
export const TypographyLink318135BrSonomaParagraphSpacing = '0rem';
export const TypographyLink318135BrSonomaTextCase = 'none';
export const TypographyLink416150BrSonomaFontSize = '16rem';
export const TypographyLink416150BrSonomaTextDecoration = 'underline';
export const TypographyLink416150BrSonomaFontFamily = 'BR Sonoma';
export const TypographyLink416150BrSonomaFontWeight = 400;
export const TypographyLink416150BrSonomaFontStyle = 'normal';
export const TypographyLink416150BrSonomaFontStretch = 'normal';
export const TypographyLink416150BrSonomaLetterSpacing = '2.5rem';
export const TypographyLink416150BrSonomaLineHeight = '24rem';
export const TypographyLink416150BrSonomaParagraphIndent = '0rem';
export const TypographyLink416150BrSonomaParagraphSpacing = '0rem';
export const TypographyLink416150BrSonomaTextCase = 'none';
export const TypographyLink514170BrSonomaFontSize = '14rem';
export const TypographyLink514170BrSonomaTextDecoration = 'underline';
export const TypographyLink514170BrSonomaFontFamily = 'BR Sonoma';
export const TypographyLink514170BrSonomaFontWeight = 400;
export const TypographyLink514170BrSonomaFontStyle = 'normal';
export const TypographyLink514170BrSonomaFontStretch = 'normal';
export const TypographyLink514170BrSonomaLetterSpacing = '2.5rem';
export const TypographyLink514170BrSonomaLineHeight = '23.8rem';
export const TypographyLink514170BrSonomaParagraphIndent = '0rem';
export const TypographyLink514170BrSonomaParagraphSpacing = '0rem';
export const TypographyLink514170BrSonomaTextCase = 'none';
export const TypographyLink612160BrSonomaFontSize = '12rem';
export const TypographyLink612160BrSonomaTextDecoration = 'underline';
export const TypographyLink612160BrSonomaFontFamily = 'BR Sonoma';
export const TypographyLink612160BrSonomaFontWeight = 500;
export const TypographyLink612160BrSonomaFontStyle = 'normal';
export const TypographyLink612160BrSonomaFontStretch = 'normal';
export const TypographyLink612160BrSonomaLetterSpacing = '2.5rem';
export const TypographyLink612160BrSonomaLineHeight = '24rem';
export const TypographyLink612160BrSonomaParagraphIndent = '0rem';
export const TypographyLink612160BrSonomaParagraphSpacing = '0rem';
export const TypographyLink612160BrSonomaTextCase = 'none';
export const TypographyButtonSmall16150BrSonomaFontSize = '16rem';
export const TypographyButtonSmall16150BrSonomaTextDecoration = 'none';
export const TypographyButtonSmall16150BrSonomaFontFamily = 'BR Sonoma';
export const TypographyButtonSmall16150BrSonomaFontWeight = 700;
export const TypographyButtonSmall16150BrSonomaFontStyle = 'normal';
export const TypographyButtonSmall16150BrSonomaFontStretch = 'normal';
export const TypographyButtonSmall16150BrSonomaLetterSpacing = '2rem';
export const TypographyButtonSmall16150BrSonomaLineHeight = '24rem';
export const TypographyButtonSmall16150BrSonomaParagraphIndent = '0rem';
export const TypographyButtonSmall16150BrSonomaParagraphSpacing = '0rem';
export const TypographyButtonSmall16150BrSonomaTextCase = 'none';
export const TypographyButtonBig28132BrSonomaFontSize = '28rem';
export const TypographyButtonBig28132BrSonomaTextDecoration = 'none';
export const TypographyButtonBig28132BrSonomaFontFamily = 'BR Sonoma';
export const TypographyButtonBig28132BrSonomaFontWeight = 400;
export const TypographyButtonBig28132BrSonomaFontStyle = 'normal';
export const TypographyButtonBig28132BrSonomaFontStretch = 'normal';
export const TypographyButtonBig28132BrSonomaLetterSpacing = '2rem';
export const TypographyButtonBig28132BrSonomaLineHeight = '39.76rem';
export const TypographyButtonBig28132BrSonomaParagraphIndent = '0rem';
export const TypographyButtonBig28132BrSonomaParagraphSpacing = '0rem';
export const TypographyButtonBig28132BrSonomaTextCase = 'none';
export const TypographySpecialTerms10145BrSonomaFontSize = '11rem';
export const TypographySpecialTerms10145BrSonomaTextDecoration = 'none';
export const TypographySpecialTerms10145BrSonomaFontFamily = 'BR Sonoma';
export const TypographySpecialTerms10145BrSonomaFontWeight = 500;
export const TypographySpecialTerms10145BrSonomaFontStyle = 'normal';
export const TypographySpecialTerms10145BrSonomaFontStretch = 'normal';
export const TypographySpecialTerms10145BrSonomaLetterSpacing = '0rem';
export const TypographySpecialTerms10145BrSonomaLineHeight = '15.95rem';
export const TypographySpecialTerms10145BrSonomaParagraphIndent = '0rem';
export const TypographySpecialTerms10145BrSonomaParagraphSpacing = '0rem';
export const TypographySpecialTerms10145BrSonomaTextCase = 'none';
export const TypographySpecialTermsLink10145BrSonomaFontSize = '10rem';
export const TypographySpecialTermsLink10145BrSonomaTextDecoration =
  'underline';
export const TypographySpecialTermsLink10145BrSonomaFontFamily = 'BR Sonoma';
export const TypographySpecialTermsLink10145BrSonomaFontWeight = 400;
export const TypographySpecialTermsLink10145BrSonomaFontStyle = 'normal';
export const TypographySpecialTermsLink10145BrSonomaFontStretch = 'normal';
export const TypographySpecialTermsLink10145BrSonomaLetterSpacing = '0rem';
export const TypographySpecialTermsLink10145BrSonomaLineHeight = '16rem';
export const TypographySpecialTermsLink10145BrSonomaParagraphIndent = '0rem';
export const TypographySpecialTermsLink10145BrSonomaParagraphSpacing = '0rem';
export const TypographySpecialTermsLink10145BrSonomaTextCase = 'none';
export const TypographySpecialNav16150BrSonomaFontSize = '16rem';
export const TypographySpecialNav16150BrSonomaTextDecoration = 'none';
export const TypographySpecialNav16150BrSonomaFontFamily = 'BR Sonoma';
export const TypographySpecialNav16150BrSonomaFontWeight = 500;
export const TypographySpecialNav16150BrSonomaFontStyle = 'normal';
export const TypographySpecialNav16150BrSonomaFontStretch = 'normal';
export const TypographySpecialNav16150BrSonomaLetterSpacing = '0.4rem';
export const TypographySpecialNav16150BrSonomaLineHeight = '24rem';
export const TypographySpecialNav16150BrSonomaParagraphIndent = '0rem';
export const TypographySpecialNav16150BrSonomaParagraphSpacing = '0rem';
export const TypographySpecialNav16150BrSonomaTextCase = 'uppercase';
export const TypographySpecialInputError12130BrSonomaFontSize = '12rem';
export const TypographySpecialInputError12130BrSonomaTextDecoration = 'none';
export const TypographySpecialInputError12130BrSonomaFontFamily = 'BR Sonoma';
export const TypographySpecialInputError12130BrSonomaFontWeight = 700;
export const TypographySpecialInputError12130BrSonomaFontStyle = 'normal';
export const TypographySpecialInputError12130BrSonomaFontStretch = 'normal';
export const TypographySpecialInputError12130BrSonomaLetterSpacing = '0rem';
export const TypographySpecialInputError12130BrSonomaLineHeight = '15.6rem';
export const TypographySpecialInputError12130BrSonomaParagraphIndent = '0rem';
export const TypographySpecialInputError12130BrSonomaParagraphSpacing = '0rem';
export const TypographySpecialInputError12130BrSonomaTextCase = 'none';
export const TypographySpecialCaption14170BrSonomaFontSize = '14rem';
export const TypographySpecialCaption14170BrSonomaTextDecoration = 'none';
export const TypographySpecialCaption14170BrSonomaFontFamily = 'BR Sonoma';
export const TypographySpecialCaption14170BrSonomaFontWeight = 500;
export const TypographySpecialCaption14170BrSonomaFontStyle = 'normal';
export const TypographySpecialCaption14170BrSonomaFontStretch = 'normal';
export const TypographySpecialCaption14170BrSonomaLetterSpacing = '0.5rem';
export const TypographySpecialCaption14170BrSonomaLineHeight = '23.8rem';
export const TypographySpecialCaption14170BrSonomaParagraphIndent = '0rem';
export const TypographySpecialCaption14170BrSonomaParagraphSpacing = '0rem';
export const TypographySpecialCaption14170BrSonomaTextCase = 'none';
export const TypographySpecialCaptionItalic14170BrSonomaFontSize = '14rem';
export const TypographySpecialCaptionItalic14170BrSonomaTextDecoration = 'none';
export const TypographySpecialCaptionItalic14170BrSonomaFontFamily =
  'BR Sonoma';
export const TypographySpecialCaptionItalic14170BrSonomaFontWeight = 500;
export const TypographySpecialCaptionItalic14170BrSonomaFontStyle = 'italic';
export const TypographySpecialCaptionItalic14170BrSonomaFontStretch = 'normal';
export const TypographySpecialCaptionItalic14170BrSonomaLetterSpacing =
  '0.5rem';
export const TypographySpecialCaptionItalic14170BrSonomaLineHeight = '23.8rem';
export const TypographySpecialCaptionItalic14170BrSonomaParagraphIndent =
  '0rem';
export const TypographySpecialCaptionItalic14170BrSonomaParagraphSpacing =
  '0rem';
export const TypographySpecialCaptionItalic14170BrSonomaTextCase = 'none';
export const TypographySpecialTmHighlight10145BrSonomaFontSize = '10rem';
export const TypographySpecialTmHighlight10145BrSonomaTextDecoration = 'none';
export const TypographySpecialTmHighlight10145BrSonomaFontFamily = 'Left 2.1';
export const TypographySpecialTmHighlight10145BrSonomaFontWeight = 500;
export const TypographySpecialTmHighlight10145BrSonomaFontStyle = 'normal';
export const TypographySpecialTmHighlight10145BrSonomaFontStretch = 'normal';
export const TypographySpecialTmHighlight10145BrSonomaLetterSpacing = '0rem';
export const TypographySpecialTmHighlight10145BrSonomaLineHeight = '16rem';
export const TypographySpecialTmHighlight10145BrSonomaParagraphIndent = '0rem';
export const TypographySpecialTmHighlight10145BrSonomaParagraphSpacing = '0rem';
export const TypographySpecialTmHighlight10145BrSonomaTextCase = 'none';
export const TypographySubtitle114168BrSonomaFontSize = '14rem';
export const TypographySubtitle114168BrSonomaTextDecoration = 'none';
export const TypographySubtitle114168BrSonomaFontFamily = 'BR Sonoma';
export const TypographySubtitle114168BrSonomaFontWeight = 500;
export const TypographySubtitle114168BrSonomaFontStyle = 'normal';
export const TypographySubtitle114168BrSonomaFontStretch = 'normal';
export const TypographySubtitle114168BrSonomaLetterSpacing = '0.5rem';
export const TypographySubtitle114168BrSonomaLineHeight = '23.52rem';
export const TypographySubtitle114168BrSonomaParagraphIndent = '0rem';
export const TypographySubtitle114168BrSonomaParagraphSpacing = '0rem';
export const TypographySubtitle114168BrSonomaTextCase = 'none';
export const TypographySubtitle212135BrSonomaFontSize = '12rem';
export const TypographySubtitle212135BrSonomaTextDecoration = 'none';
export const TypographySubtitle212135BrSonomaFontFamily = 'BR Sonoma';
export const TypographySubtitle212135BrSonomaFontWeight = 500;
export const TypographySubtitle212135BrSonomaFontStyle = 'normal';
export const TypographySubtitle212135BrSonomaFontStretch = 'normal';
export const TypographySubtitle212135BrSonomaLetterSpacing = '0.5rem';
export const TypographySubtitle212135BrSonomaLineHeight = '16.2rem';
export const TypographySubtitle212135BrSonomaParagraphIndent = '0rem';
export const TypographySubtitle212135BrSonomaParagraphSpacing = '0rem';
export const TypographySubtitle212135BrSonomaTextCase = 'none';
export const TypographyOversize1192121Left21FontSize = '192rem';
export const TypographyOversize1192121Left21TextDecoration = 'none';
export const TypographyOversize1192121Left21FontFamily = 'Left 2.1';
export const TypographyOversize1192121Left21FontWeight = 500;
export const TypographyOversize1192121Left21FontStyle = 'normal';
export const TypographyOversize1192121Left21FontStretch = 'normal';
export const TypographyOversize1192121Left21LetterSpacing = -3.84;
export const TypographyOversize1192121Left21LineHeight = '232.32rem';
export const TypographyOversize1192121Left21ParagraphIndent = '0rem';
export const TypographyOversize1192121Left21ParagraphSpacing = '0rem';
export const TypographyOversize1192121Left21TextCase = 'none';
export const TypographyOversize2128128Left21FontSize = '128rem';
export const TypographyOversize2128128Left21TextDecoration = 'none';
export const TypographyOversize2128128Left21FontFamily = 'Left 2.1';
export const TypographyOversize2128128Left21FontWeight = 500;
export const TypographyOversize2128128Left21FontStyle = 'normal';
export const TypographyOversize2128128Left21FontStretch = 'normal';
export const TypographyOversize2128128Left21LetterSpacing = -2.56;
export const TypographyOversize2128128Left21LineHeight = '144rem';
export const TypographyOversize2128128Left21ParagraphIndent = '0rem';
export const TypographyOversize2128128Left21ParagraphSpacing = '0rem';
export const TypographyOversize2128128Left21TextCase = 'none';
export const TypographyOversize36464Left21FontSize = '64rem';
export const TypographyOversize36464Left21TextDecoration = 'none';
export const TypographyOversize36464Left21FontFamily = 'Left 2.1';
export const TypographyOversize36464Left21FontWeight = 500;
export const TypographyOversize36464Left21FontStyle = 'normal';
export const TypographyOversize36464Left21FontStretch = 'normal';
export const TypographyOversize36464Left21LetterSpacing = -1.28;
export const TypographyOversize36464Left21LineHeight = '64rem';
export const TypographyOversize36464Left21ParagraphIndent = '0rem';
export const TypographyOversize36464Left21ParagraphSpacing = '0rem';
export const TypographyOversize36464Left21TextCase = 'none';
